import { openBlock as t, createElementBlock as r, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, l) {
  return t(), r("svg", o, [...l[0] || (l[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M20.25 4H7.125c-.604 0-1.076.311-1.391.782L1 12l4.734 7.209c.315.471.787.791 1.391.791H20.25c.962 0 1.75-.8 1.75-1.778V5.778C22 4.8 21.212 4 20.25 4m0 14.222H7.186L3.1 12l4.078-6.222H20.25zm-10.141-1.778 3.141-3.19 3.141 3.19 1.234-1.253L14.484 12l3.141-3.191-1.234-1.253-3.141 3.19-3.141-3.19-1.234 1.253L12.016 12l-3.141 3.191z"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
